import Model from "~/models/_Model";
import Department from "./Department";
import EquipmentType from "./EquipmentType";
import Location from "./Location";

export default class System extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/techloaner";
  }

  // Set the resource route of the model
  resource() {
    return "metadata";
  }

  relations() {
    return {
      departments: Department,
      equipment_types: EquipmentType,
      locations: Location,
    };
  }
}
